import { render, staticRenderFns } from "./PostItem.vue?vue&type=template&id=c143d1b8&scoped=true"
import script from "./PostItem.vue?vue&type=script&lang=js"
export * from "./PostItem.vue?vue&type=script&lang=js"
import style0 from "./PostItem.vue?vue&type=style&index=0&id=c143d1b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c143d1b8",
  null
  
)

export default component.exports